import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingCTA from './components/FloatingCTA';
import ScrollToTop from './components/ScrollToTop';

// Sider
import Home from './pages/Home';
import Stiklinger from './pages/Stiklinger';
import BestilKnolde from './pages/BestilKnolde';
import Bordpynt from './pages/Bordpynt';
import Arrangementer from './pages/Arrangementer';
import OmOs from './pages/OmOs';
import GalleriPage from './pages/GalleriPage';
import Kontakt from './pages/Kontakt';
import Redigeringsguide from './pages/Redigeringsguide';
import Forbidden from './pages/Forbidden';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <div className="relative min-h-screen flex flex-col bg-white text-charcoal-900 antialiased font-sans">
      {/* Scroll Restoration */}
      <ScrollToTop />

      {/* Header */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/stiklinger" element={<Stiklinger />} />
          <Route path="/bestil-knolde" element={<BestilKnolde />} />
          <Route path="/ideer-til-bordpynt-og-dekorationer" element={<Bordpynt />} />
          <Route path="/arrangementer" element={<Arrangementer />} />
          <Route path="/om-os" element={<OmOs />} />
          <Route path="/galleri" element={<GalleriPage />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/redigeringsguide" element={<Redigeringsguide />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />

      {/* Sticky Floating CTA */}
      <FloatingCTA />
    </div>
  );
}
